import React from "react";
import { Box, Typography, Select, MenuItem, SelectChangeEvent } from "@mui/material";

interface YearPickerProps {
  value: number | null; 
  onChange?: (year: number | null) => void;
  placeholder?: string; 
}

const YearPicker: React.FC<YearPickerProps> = ({ value, onChange, placeholder = "Select Year" }) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const val = event.target.value;
    const year = val ? Number(val) : null;
    onChange?.(year);
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Year
      </Typography>
      <Select
        size="small"
        value={value?.toString() ?? ""}
        onChange={handleChange}
        displayEmpty
        sx={{
          minWidth: 150,
          minHeight: 36,
          ".MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            height: "100%",
          },
        }}
        renderValue={(selected) => {
          if (!selected) {
            return <span style={{ color: "#999" }}>{placeholder}</span>; 
          }
          return selected;
        }}
      >
        {years.map((y) => (
          <MenuItem key={y} value={y.toString()}>
            {y}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default YearPicker;
